import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { FaAngleDown } from "react-icons/fa6";

import Dropdown from "react-bootstrap/Dropdown";

import { Select } from "antd";

import { TbLogout } from "react-icons/tb";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch, useSelector } from "react-redux";
import { logout } from "../../slices/authSlice";
const { Option } = Select;

const Header = () => {
  const Data = localStorage?.getItem("userData");
  const userData = JSON.parse(Data);
  const token = useSelector((state) => state.auth.token);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const HandleLogout = () => {
    localStorage.removeItem("userData");
    //console.log(localstorage)
    dispatch(logout());
    navigate("/");
  };
  return (
    <>
      <header>
        <div className="row">
          <div className="col-xl-5"></div>
          <div className="col-xl-7">
            <div className="rightMenu">
              <ul>
                {token ? (
                  <li className="userClass">
                    <Dropdown>
                      <Dropdown.Toggle
                        className="userBtn btn"
                        id="dropdown-basic"
                      >
                        {/* <img className="me-2" src="/Image/user.png" /> */}
                        Admin
                        <FaAngleDown />
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item href="#" onClick={HandleLogout}>
                          <span>
                            <TbLogout />
                          </span>{" "}
                          Log Out
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </li>
                ) : (
                  <li className="loginBtn">
                    <Link>Login</Link>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
